import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import KanbanRoute from '../../kanban/KanbanRoute.vue';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import EditPipeline from './EditPipeline.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/pipelines'),
      component: KanbanRoute,
      children: [
        {
          path: '',
          component: SettingsWrapper,
          children: [
            {
              path: '',
              name: 'pipelines_wrapper',
              meta: {
                featureFlag: FEATURE_FLAGS.KANBAN,
                permissions: ['administrator'],
              },
              redirect: to => {
                return { name: 'pipelines_list', params: to.params };
              },
            },
            {
              path: 'list',
              name: 'pipelines_list',
              meta: {
                featureFlag: FEATURE_FLAGS.KANBAN,
                permissions: ['administrator'],
              },
              component: Index,
            },
            {
              path: ':pipelineId/edit',
              name: 'pipeline_edit',
              meta: {
                featureFlag: FEATURE_FLAGS.KANBAN,
                permissions: ['administrator'],
              },
              component: EditPipeline,
            },
          ],
        },
      ],
    },
  ],
};
